import { useEffect, useState } from 'react';

import FilterByEnum from '../../../../enumerations/FilterBy';
import { getContextDataFromFilterBy } from '../testPurchaseFiltersHelpers';

const useTestPurchaseDomains = ({
  context,
  filtersSelected,
  hasSomeQueryParams,
  initialSelectedFilterBy,
  isEnableFilterByTenant,
  testPurchaseFetchDomains,
  validQueryParams,
}) => {
  const [contractIdToFetch, setContractIdToFetch] = useState(null);
  const [customerIdToFetch, setCustomerIdToFetch] = useState(null);

  const filterBy = hasSomeQueryParams
    ? validQueryParams.filterBy
    : filtersSelected.filterBy;

  useEffect(() => {
    if (
      isEnableFilterByTenant != null &&
      customerIdToFetch === null &&
      contractIdToFetch === null
    ) {
      let filterByToFetch = filterBy;

      if (
        isEnableFilterByTenant === false &&
        filterBy === FilterByEnum.TENANT.name
      ) {
        filterByToFetch = initialSelectedFilterBy;
      }

      const { customerId, contractId } = getContextDataFromFilterBy(
        filterByToFetch,
        context
      );

      setCustomerIdToFetch(customerId);
      setContractIdToFetch(contractId);
    }
  }, [
    context,
    contractIdToFetch,
    customerIdToFetch,
    filterBy,
    initialSelectedFilterBy,
    isEnableFilterByTenant,
  ]);

  useEffect(() => {
    if (customerIdToFetch !== null && contractIdToFetch !== null) {
      testPurchaseFetchDomains({
        customerId: customerIdToFetch,
        contractId: contractIdToFetch,
      });
    }
  }, [contractIdToFetch, customerIdToFetch, testPurchaseFetchDomains]);
};

export default useTestPurchaseDomains;
